<template>
  <svg
    width="256"
    height="256"
    viewBox="0 0 256 256"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M107.303 112.966C111.724 112.966 115.309 109.382 115.309 104.96C115.309 100.538 111.724 96.9536 107.303 96.9536C102.881 96.9536 99.2961 100.538 99.2961 104.96C99.2961 109.382 102.881 112.966 107.303 112.966Z"
      class="fill-secondary-500"
    />
    <path
      d="M228.096 139.565V102.477C228.096 97.12 223.712 92.736 218.355 92.736C212.999 92.736 208.615 97.12 208.615 102.477V139.59C215.111 139.578 221.6 139.546 228.096 139.565Z"
      class="fill-brand-300"
    />
    <path
      d="M194.765 124.013H151.968C144.316 124.013 138.112 130.216 138.112 137.869C138.112 145.521 144.316 151.725 151.968 151.725H194.765C202.417 151.725 208.621 145.521 208.621 137.869C208.621 130.216 202.417 124.013 194.765 124.013Z"
      class="fill-secondary-500"
    />
    <path
      d="M203.117 107.296H156.371C153.335 107.296 150.874 109.757 150.874 112.794V118.515C150.874 121.551 153.335 124.013 156.371 124.013H203.117C206.153 124.013 208.615 121.551 208.615 118.515V112.794C208.615 109.757 206.153 107.296 203.117 107.296Z"
      class="fill-brand-100"
    />
    <path
      d="M188.499 85.1968H163.136C159.806 85.1968 157.107 87.896 157.107 91.2256V101.363C157.107 104.693 159.806 107.392 163.136 107.392H188.499C191.829 107.392 194.528 104.693 194.528 101.363V91.2256C194.528 87.896 191.829 85.1968 188.499 85.1968Z"
      class="fill-secondary-500"
    />
    <path
      d="M135.398 116.742C147.215 116.742 156.794 107.163 156.794 95.3472C156.794 83.531 147.215 73.952 135.398 73.952C123.582 73.952 114.003 83.531 114.003 95.3472C114.003 107.163 123.582 116.742 135.398 116.742Z"
      class="fill-brand-100"
      stroke="#BCDBE5"
      stroke-width="1.15"
      stroke-miterlimit="10"
    />
    <path
      d="M161.536 85.2928C168.969 85.2928 174.995 79.2669 174.995 71.8336C174.995 64.4003 168.969 58.3744 161.536 58.3744C154.103 58.3744 148.077 64.4003 148.077 71.8336C148.077 79.2669 154.103 85.2928 161.536 85.2928Z"
      class="fill-brand-300"
    />
    <path
      d="M119.731 112.659H88.1922C83.5583 112.659 79.8018 116.416 79.8018 121.05V152.589C79.8018 157.223 83.5583 160.979 88.1922 160.979H119.731C124.365 160.979 128.122 157.223 128.122 152.589V121.05C128.122 116.416 124.365 112.659 119.731 112.659Z"
      class="fill-secondary-500"
    />
    <path
      d="M236.378 138.323H62.0864V250.214H236.378V138.323Z"
      class="fill-brand-300"
    />
    <path
      d="M86.9056 182.88H116.045C118.182 182.88 119.917 184.614 119.917 186.752V250.221H83.04V186.752C83.04 184.614 84.7744 182.88 86.912 182.88H86.9056Z"
      class="fill-brand-100"
    />
    <path
      d="M142.56 166.63H168.403C169.946 166.63 171.2 167.885 171.2 169.427V204.813H139.763V169.427C139.763 167.885 141.018 166.63 142.56 166.63Z"
      class="fill-brand-100"
    />
    <path
      d="M189.894 166.63H215.738C217.28 166.63 218.534 167.885 218.534 169.427V204.813H187.098V169.427C187.098 167.885 188.352 166.63 189.894 166.63Z"
      class="fill-brand-100"
    />
    <path
      d="M187.834 6.40002H52.7297C50.8545 6.40002 49.3377 7.91682 49.3377 9.79202V81.024L35.2129 66.8992C33.2417 64.928 30.0481 64.928 28.0833 66.8992L21.3185 73.664C19.3473 75.6352 19.3473 78.8224 21.3185 80.7936L49.3377 108.813V144.89C49.3377 147.91 52.9921 149.427 55.1297 147.29L190.234 12.192C192.371 10.0544 190.854 6.40002 187.834 6.40002Z"
      class="fill-brand-500"
    />
    <path
      d="M91.4049 66.464C98.4988 66.464 104.25 60.7132 104.25 53.6192C104.25 46.5252 98.4988 40.7744 91.4049 40.7744C84.3109 40.7744 78.5601 46.5252 78.5601 53.6192C78.5601 60.7132 84.3109 66.464 91.4049 66.464Z"
      class="fill-brand-100"
    />
  </svg>
</template>

<script>
  export default {
    name: 'PayByExtendingMortgage'
  }
</script>
